module.exports = "/assets/82cb1a7a89dd5fe1cc51862869944659.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/I9.png
// module id = 1466
// module chunks = 0